"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AxiosRefreshTokenInterceptor = void 0;
const hub_utilities_replenishment_1 = require("@yw/hub.utilities.replenishment");
const js_cookie_1 = __importDefault(require("js-cookie"));
const types_1 = require("../../../domain/types");
const axios_1 = __importDefault(require("axios"));
class AxiosRefreshTokenInterceptor {
    constructor(axiosInstance, config) {
        this.axiosInstance = axiosInstance;
        this.config = config;
        this.isRefreshing = false;
        this.subscribers = [];
        this.config = (0, hub_utilities_replenishment_1.merge)({
            accessTokenKey: types_1.AuthTokenType.ACCESS_TOKEN,
        }, this.config);
    }
    setupInterceptor() {
        this.addResponseInterceptor();
    }
    addResponseInterceptor() {
        this.axiosInstance.interceptors.response.use((response) => {
            if (response.data.code === types_1.EndpointStatusCodes.Unauthorized ||
                response.data.code === 70001) {
                const refreshToken = this.getCookieAccessToken(response.config.refreshTokenKey);
                if (refreshToken &&
                    !response.config.retry &&
                    response.config.refreshTokenUrl) {
                    response.config.retry = true;
                    if (!this.isRefreshing) {
                        this.isRefreshing = true;
                        this.refreshToken(refreshToken, response.config.refreshTokenUrl, response.config.refreshTokenKey, response.config.errorCallback);
                    }
                    return new Promise((resolve, reject) => {
                        this.subscribeTokenRefresh((accessToken) => {
                            response.config.headers.Authorization = `Bearer ${accessToken}`;
                            resolve(axios_1.default.request(response.config).catch(reject));
                        });
                    });
                }
            }
            return response;
        }, (error) => {
            const { config, response } = error;
            const refreshToken = this.getCookieAccessToken(config.refreshTokenKey);
            if (((response === null || response === void 0 ? void 0 : response.status) === 401 || ((response === null || response === void 0 ? void 0 : response.status) === 400 && config.phpSpecial)) &&
                !config.retry &&
                refreshToken &&
                config.refreshTokenUrl) {
                config.retry = true;
                if (!this.isRefreshing) {
                    this.isRefreshing = true;
                    this.refreshToken(refreshToken, config.refreshTokenUrl, config.refreshTokenKey, config.errorCallback);
                }
                return new Promise((resolve, reject) => {
                    this.subscribeTokenRefresh((accessToken) => {
                        config.headers.Authorization = `Bearer ${accessToken}`;
                        resolve(axios_1.default.request(config).catch(reject));
                    });
                });
            }
            return Promise.reject(error);
        });
    }
    refreshToken(accessToken, refreshTokenUrl, refreshTokenKey, errorCallback) {
        axios_1.default
            .request({
            url: refreshTokenUrl,
            method: 'POST',
            data: { accessToken },
            headers: {
                Authorization: 'Bearer ' + accessToken,
            },
        })
            .then((resp) => {
            if (resp.data.code !== 20000) {
                errorCallback && errorCallback();
            }
            else {
                this.onRefreshed({
                    access_token: resp.data.data.access_token,
                    expires_in: resp.data.data.expires_in,
                }, refreshTokenKey);
                this.subscribers.forEach((callback) => callback(resp.data.data.access_token));
                this.subscribers = [];
            }
        })
            .catch(() => {
            errorCallback && errorCallback();
        })
            .finally(() => {
            this.isRefreshing = false;
        });
    }
    getCookieAccessToken(key) {
        return JSON.parse(js_cookie_1.default.get(key) || '{}').access_token;
    }
    onRefreshed(identity, key) {
        js_cookie_1.default.set(key, JSON.stringify(identity), {
            httpOnly: false,
            signed: false,
            domain: window.location.hostname === 'localhost' ? '' : '.chinagoods.com',
            expires: 365,
        });
    }
    subscribeTokenRefresh(callback) {
        this.subscribers.push(callback);
    }
}
exports.AxiosRefreshTokenInterceptor = AxiosRefreshTokenInterceptor;
//# sourceMappingURL=AxiosRefreshTokenInterceptor.js.map